import { Button, VStack } from 'native-base';
import React from 'react';
import { useDownloadDocument } from '../../Common/hooks/useDownloadDocument';
import { Icon } from '../../Common/components/Icon';
import { faDownload } from '@fortawesome/pro-solid-svg-icons/faDownload';
import { useRouting } from '../../Common/hooks/useRouting';

export function MessagePathologyRequest({
  pathRequestID,
  consultID,
  docKey,
}: {
  pathRequestID: string;
  consultID: string;
  docKey: string;
}) {
  const { downloadingDocument, onPressDownload } = useDownloadDocument();

  const { navigate } = useRouting();

  return (
    <VStack space={1}>
      <Button
        leftIcon={<Icon icon={faDownload} size={'sm'} color={'white'} />}
        isLoading={downloadingDocument}
        onPress={() => onPressDownload(docKey, consultID)}
        size={'sm'}
      >
        Download Form
      </Button>

      <Button
        onPress={() => navigate(`/profile/health/pathology/${pathRequestID}`)}
        _text={{ color: 'white' }}
        variant={'outline'}
        size={'sm'}
      >
        View Request
      </Button>
    </VStack>
  );
}
